import { useGetOrderDetail } from "hooks/useOrders";
import { CreditCardOutlined } from "@ant-design/icons";
import { Button, InputNumber, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useEffect } from "react";

interface ModalBoxCountProps {
  isModalLabel: boolean;
  //boxcount: number;
  // setBoxcount: React.Dispatch<React.SetStateAction<number>>;
  setisModalLabel: React.Dispatch<React.SetStateAction<boolean>>;
  orderId: string;
}

const ModalBoxCount = ({
  isModalLabel,
  // boxcount,
  //setBoxcount,
  setisModalLabel,
  orderId,
}: ModalBoxCountProps) => {
  const { mutate, isPending } = useGetOrderDetail();

  const [boxcount, setBoxcount] = React.useState(0);

  console.log(orderId);

  useEffect(() => {
    mutate(
      {
        key_type: "order_id",
        group_by: "factory",
        items: [orderId ?? ""],
      },
      {
        onSuccess: (data) => {
          // console.log(data?.data[0]?.history_transport.transport_box || 0);

          if (data) {
            //sum box_list 
            let sum = 0;
            data?.data[0]?.history_transport?.box_list?.map((item) => {
              sum += item.qty;
            }
            );

            setBoxcount(sum);
          }
        },
      }
    );
  }, [orderId, isModalLabel, mutate]);

  return (
    <>
      <Modal
        title="เพิ่มจำนวนกล่องที่ส่ง"
        open={isModalLabel}
        onCancel={() => {
          setisModalLabel(false);
         // setBoxcount(1);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setisModalLabel(false);
             // setBoxcount(1);
            }}
          >
            ยกเลิก
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setisModalLabel(false);

              window.open(
                `/print-label/?orderId=${orderId}&boxcount=${boxcount}`
              );

             // setBoxcount(1);
            }}
          >
            พิมพ์ Label
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 4,
          }}
        >
          <Typography.Text>จำนวนกล่องที่ส่ง : </Typography.Text>

          {isPending ? (
            <Spin />
          ) : (
            <InputNumber
              min={1}
              max={100}
              defaultValue={boxcount}
              value={boxcount}
              onChange={(value) => {
                setBoxcount(value as number);
              }}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ModalBoxCount;
